import type { CookieSerializeOptions } from 'cookie-es'

export const TOKEN_COOKIE_NAME = '_T_'

export const CSRF_ERROR_MESSAGE = 'APP CSRF Token Mismatch'

export const COOKIE_SETTINGS: CookieSerializeOptions = {
  path: '/',
  httpOnly: false,
  maxAge: 60 * 60 * 24 * 14,
  sameSite: 'strict',
}
